export default __webpack_public_path__ + "static/media/status_dark.497cdf06.svg";